import type { CSSProperties } from 'react'

import { cn } from '@/shared/lib/cn'
import { companyHueStyle, hueToCss } from '@/shared/lib/company-hue'

export interface CompanySpineProps {
  /** Hue fijo de la empresa (0-359), tal como lo guarda `companies.color_hue`. */
  hue: number
  /** `row` = 3px vertical a la izquierda de una fila. `top` = 3px horizontal arriba de una tarjeta. */
  orientation?: 'row' | 'top'
  className?: string
  /** Nombre de la empresa, para el `title` accesible. */
  label?: string
}

/**
 * La espina de empresa: 3px con el hue de la empresa, a la izquierda de cada
 * fila, tarjeta y encabezado.
 *
 * NUNCA como fondo ni relleno grande. Ese es el punto: los colores semanticos
 * (vencida, por vencer, en curso) quedan libres y no compiten con la identidad
 * de la empresa.
 *
 * Es decorativa: `aria-hidden`. El nombre de la empresa siempre esta ademas en
 * texto — el color solo nunca comunica.
 */
export function CompanySpine({ hue, orientation = 'row', className, label }: CompanySpineProps) {
  const style: CSSProperties = {
    ...companyHueStyle(hue),
    backgroundColor: hueToCss(hue),
  }

  return (
    <span
      aria-hidden="true"
      title={label}
      style={style}
      className={cn(
        'shrink-0 rounded-full',
        orientation === 'row'
          ? 'h-full w-[var(--spine-w)] self-stretch'
          : 'h-[var(--spine-w)] w-full',
        className,
      )}
    />
  )
}
